import React from 'react';
import { StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useLinkedAccountsColors } from '@/constants/residents/mobile/linkedAccountsColors';
import { newInvitationStrings } from '@/constants/residents/strings';
import { UnifiedModal } from '@/components/common/UnifiedModal';

interface InfoBubbleModalProps {
  visible: boolean;
  onClose: () => void;
}

export const InfoBubbleModal: React.FC<InfoBubbleModalProps> = ({
  visible,
  onClose,
}) => {
  const LAC = useLinkedAccountsColors();

  return (
    <UnifiedModal
      visible={visible}
      onClose={onClose}
      variant="sheet"
      title={newInvitationStrings.howItWorks.item2.title}
      showHeader
      scrollable
      contentContainerStyle={styles.scrollContent}
    >
      <Text style={[styles.descriptionText, { color: LAC.textSecondary }]}>
        {newInvitationStrings.howItWorks.item2.detail}
      </Text>
    </UnifiedModal>
  );
};

const styles = StyleSheet.create({
  descriptionText: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 21,
    paddingBottom: 8, // horizontal inset comes from the modal's scroll container (24)
  },
  // The scroll container also pads 24 at the bottom; the text already has its 8.
  scrollContent: {
    paddingBottom: 0,
  },
});
